import { AxiosError } from 'axios';

import { changeTariffFromBackend } from '@entities/tariff/lib';
import { $api } from '@shared/api';

async function unwrapAxiosData(data: unknown) {
    if (data instanceof Blob) {
        const text = await data.text();

        try {
            return JSON.parse(text);
        } catch {
            return text;
        }
    }
    return data;
}

export const exportEstimateInformation = async () => {
    // @ts-expect-error routable injected globally
    const url = routable.getRoute('exportPurchaseAct');
    const sortOrder = document.querySelector<HTMLElement>(
        '.estimate-purchases .table-body.sortable-body ul'
    )?.dataset.sortOrder;

    try {
        const res = await $api.get(url, {
            params: sortOrder ? { 'sort_order': sortOrder } : undefined,
            responseType: 'blob',
        });
        const filename = res.headers?.['content-disposition'] ?? 'purchase-act';

        const downloadUrl = URL.createObjectURL(res.data);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);
    } catch (e) {
        const err = e as AxiosError;
        const data = await unwrapAxiosData(err.response?.data);

        if (data && typeof data === 'object' && data.status === 'tariff-error') {
            await changeTariffFromBackend(data.tariff_popup_url);
        }
    }
};
